import {Component} from 'san';
import styles from './style/index.module.less';

export default class Vote extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles
        };
    }
    static computed = {
        itemData() {
            return this.data.get('data.data');
        }
    }
};